import { AutoSetupCategory } from 'app/frontend/types/custom/AutoSetupSettings'

export type AutoSetupCategoryMeta = {
  category: AutoSetupCategory
  label: string
  tooltip: string
}

export const autoSetupCategoryMeta: AutoSetupCategoryMeta[] = [
  {
    category: 'loot',
    label: 'Loot',
    tooltip:
      'Prioritises selecting characters who still need loot from the encounter (up to 2 characters per item, best-in-slot first). Characters with a bonus roll target for the encounter get top priority',
  },
  {
    category: 'experience',
    label: 'Experience',
    tooltip:
      'Prioritises selecting characters who have killed the boss before (or, with 0 kills, who have been selected most in previous events)',
  },
  {
    category: 'itemLevel',
    label: 'Item level',
    tooltip: 'Prioritises characters with a higher item level',
  },
  {
    category: 'composition',
    label: 'Composition',
    tooltip:
      'Prioritises at least one character of each class, and a ranged-melee balance that matches your previous setups or top logs for the encounter',
  },
  {
    category: 'randomness',
    label: 'Randomness',
    tooltip:
      'Choose between full determinism or random variance each time you generate a setup',
  },
  {
    category: 'equality',
    label: 'Equality',
    tooltip:
      'Prioritise distributing selection amount equally across all characters.',
  },
]
